"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedInInsightTag = void 0;
const script_1 = __importDefault(require("next/script"));
const react_1 = __importDefault(require("react"));
const LinkedInInsightTag = (props) => {
    const partnerId = props.partnerId || process.env.NEXT_PUBLIC_LINKEDIN_PARTNER_ID;
    return (react_1.default.createElement(react_1.default.Fragment, null, partnerId && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(script_1.default, null, `
              _linkedin_partner_id = "${partnerId}";
              window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
              window._linkedin_data_partner_ids.push(_linkedin_partner_id);
            `),
        react_1.default.createElement(script_1.default, null, `
              (function(l) {
              if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
              window.lintrk.q=[]}
              var s = document.getElementsByTagName("script")[0];
              var b = document.createElement("script");
              b.type = "text/javascript";b.async = true;
              b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
              s.parentNode.insertBefore(b, s);})(window.lintrk);
            `),
        react_1.default.createElement("noscript", null,
            react_1.default.createElement("img", { height: "1", width: "1", style: { display: 'none' }, alt: "", src: `https://px.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif` }))))));
};
exports.LinkedInInsightTag = LinkedInInsightTag;
